module.exports = __webpack_public_path__ + "img/img-coin.66b3f229.png";